import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import StripeElementsProvider from '~/providers/StripeElementsProvider';
import { ClientDetailsPaymentMethods } from './ClientDetailsPaymentMethods';
export const GetAddPaymentMethodModalTID = (parentTestId)=>getTestIds(parentTestId);
export function AddPaymentMethodModal(param) {
    let { clientId, dismissModal, testId } = param;
    const { AddPaymentMethodModalTestIds: TID } = useMemo(()=>GetAddPaymentMethodModalTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(StripeElementsProvider, {
        children: /*#__PURE__*/ _jsx(ClientDetailsPaymentMethods, {
            clientId: clientId,
            dismissModal: dismissModal,
            testId: TID.Root()
        })
    });
}
